import React from "react";
import imgSvg from "../../assets/loader.svg";

function LoadingScreen() {
  const loadingScreenStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(5, 4, 33, 0.49)",
    color: "#ffffff",
    minHeight: "100vh"
  };
  return (
    <div style={loadingScreenStyle} className="mpng-ux-loading-screen">
      <div>
        <img src={imgSvg} alt="" width="100%" height="100%" />
        <br />
        <span>Loading</span>
      </div>
    </div>
  );
}

export default LoadingScreen;
